import { MaintenanceIcon } from '@collinsonx/design-system/assets/icons';
import {
  Anchor,
  Box,
  Center,
  Container,
  Flex,
  Stack,
  Text,
} from '@collinsonx/design-system/core';
import { useViewportSize } from '@collinsonx/design-system/hooks';
import LayoutLogin from '@components/LayoutLogin';
import { getFAQUrl, redirectTo } from 'config/navigation';
import useLocale from 'hooks/useLocale';
import usePayload from 'hooks/usePayload';

import classes from './Maintenance.module.css';

const Maintenance = () => {
  const { payload } = usePayload();
  const { height } = useViewportSize();
  const translations = useLocale();

  const handleSupportClick = () => {
    redirectTo(getFAQUrl(payload?.accountProvider));
  };

  return (
    <LayoutLogin>
      <Center h={`${height / 2 + 116}px`}>
        <Container className={classes.container}>
          <Box className={classes.innerContainer} p={20}>
            <Stack align="center" gap={8}>
              <Flex align="center" direction="row" gap="xs" justify="center">
                <MaintenanceIcon />
                <Text fw={700} size="xl" ta="center">
                  {translations.auth.maintenance.title}{' '}
                </Text>
              </Flex>
              <Text ta="center">
                {translations.auth.maintenance.description}
              </Text>
              <Flex align="center" direction="row" gap="xs" justify="center">
                <Text>{translations.auth.maintenance.note}</Text>

                <Center>
                  <Anchor
                    className={classes.contact}
                    fw={600}
                    onClick={handleSupportClick}
                    size="lg"
                  >
                    {translations.auth.maintenance.btn.support}
                  </Anchor>
                </Center>
              </Flex>
            </Stack>
          </Box>
        </Container>
      </Center>
    </LayoutLogin>
  );
};
export default Maintenance;
